module.exports = __webpack_public_path__ + "img/affiliate.f93d9359.jpg";